import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createChart } from '@/features/charts/api/create-chart';
import { useToast } from '@/shared/hooks/use-toast';

export const useCreateChartMutation = () => {
  const { toast } = useToast();
  const { t } = useTranslation('chart', { keyPrefix: 'chart_creation' });

  return useMutation({
    mutationFn: createChart,
    onError: (error) => {
      toast({
        title: t('errors.create_error'),
        description: error.message,
      });
    },
  });
};
